export const BASEURL = process.env.REACT_APP_NEW_API_END_POINT;
export const ANALYTICSBASEURL = process.env.REACT_APP_ANALYTICS_API_URL;
export const CLIENTAPPID = process.env.REACT_APP_CLIENTAPPID;
export const LOCAL_STORAGE_PREFIX = process.env.REACT_APP_LOCAL_STORAGE_PREFIX;
export const LOCAL_STORAGE_KEY = process.env.REACT_APP_LOCAL_STORAGE;
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;
export const REQUEST_TIMEOUT = 2 * 60 * 1000;
export const MEDIASTORAGE_URL = process.env.REACT_APP_MEDIASTORAGE_URL;
export const MAP_IMAGE_URL = process.env.REACT_APP_MAP_IMAGE_URL;
export const MAP_IMAGE_KEY = process.env.REACT_APP_MAP_IMAGE_KEY;
export const OCR_API_URL = process.env.REACT_APP_OCR_API_URL;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const COBROWSE_SDK_URL = process.env.REACT_APP_COBROWSE_SDK_URL;
export const COBROWSE_LICENSE_KEY = process.env.REACT_APP_COBROWSE_LICENSE_KEY;
export const REACT_APP_SITE_URL = process.env.REACT_APP_SITE_URL;
export const CALLSTATS_APPID = process.env.REACT_APP_CALLSTATS_APPID;
export const CALLSTATS_APPSECRET = process.env.REACT_APP_CALLSTATS_APPSECRET;
export const AZURE_TRANSLATOR_KEY = process.env.REACT_APP_AZURE_TRANSLATOR_KEY;
export const AZURE_TRANSLATOR_REGION = process.env.REACT_APP_AZURE_TRANSLATOR_REGION;
export const AZURE_TRANSLATOR_ENDPOINT = "https://api.cognitive.microsofttranslator.com";
export const VERSION_KEY = "version";
export const Token_time = 6900;
export const DEVICETYPE = "4"; // 4 - web
export const APPVERSION = "7";
export const ReservedDomain = [
    "showmedev.blitzz.co",
    "journeydev.blitzz.co",
    "rc.blitzz.co",
    "joinrc.blitzz.co",
    "web.blitzz.co",
    "join.blitzz.co",
    "dev.blitzz.co",
    "journeydev.blitzz.app", // not in the old portal list
    "rc.blitzz.us", // not in the old portal list
];
export const LOCAL_DOMAIN_NAME_FOR_TESTING = "webtest.blitzz.app"; // for local
export const INVALID_DOMAIN_URL = "https://blitzz.co/invalid-domain/";
export const poweredBy = "https://www.blitzz.co/powered-by/";
export const validSessionIDLength = 9;
export const APP_URL_ANDROID = "https://play.google.com/store/apps/details?id=co.blitzz.showme";
export const APP_URL_IOS = "https://itunes.apple.com/us/app/showme-by-blitzz/id1455127791?ls=1&mt=8";
export const ENABLED = "1";
export const DISABLE = "0";
export const BATTERY_CRITICAL_VALUE = 15;
export const CELLULAR_TYPE_ARRAY = ["SLOW-2G", "2G", "3G", "4G", "5G", "LTE"];
export const SPEED_TEST_LINK = "https://live-test.speedtestcustom.com/";
export const GOOGLE_AR_SUPPORTED_DEVICES_URL = "https://developers.google.com/ar/devices";
export const NETWORK = {
    CELLULAR: "CELLULAR",
    WIFI: "WIFI",
    ETHERNET: "ETHERNET",
    Unknown: "Unknown",
};
export const REDIRECTION = {
    COUNTER_SECOND: 99,
    TIMER_MINIMUM_VALUE: 0,
    TIMER_MAXIMUM_VALUE: 100,
};

export const LOCAL_STORAGE_KEYS = {
    CONFIG_DATA: "configdata",
    TOKEN_EXPIRY_TIME: "tokenexpirytime",
    USER_TOKEN: "uToken",
    REFRESH_TOKEN: "refreshToken",
    ALL_TOKEN_TIME: "alltokentime",
    UCID: "ucid",
    BETA: "beta",
    ALLOW_ZENDESK: "allowzendesk",
    COMPANY_LIST: "companylist",
    CURRENT_COMPANY: "currentcompany",
    AFTER_LOGIN: "afterLogin",
    SELECTED_USER_ID: "selecteduserid",
    SELECTED_USER_INFO: "selectuserinfo",
    HEADER_OBJ: "apiHeaderOBj",
    USER: "user",
    TOKEN: "token",
    LOGIN_NAME: "LoginName",
    USER_LANGUAGE: "usersLanguage",
    LOGGED_IN: "logged_in",
    SUBSCRIPTION_TYPE: "subscriptiontype",
    IS_TRIAL: "istrial",
    EDITION: "edition",
    DOMAIN_CONFIGURATION: "domainConfiguration",
    IDEAL_LOGOUT_FLAG: "idleLogoutFlag",
    USERS_LANGUAGE: "usersLanguage",
    PREV_COUNTRY_CODE: "precountrycode",
    MAP_TYPE_ID: "mapTypeId",
    NOT_ALLOWED_TO_REJOIN_PARTICIPANT: "notAllowedToRejoinParticipant",
    VIRTUAL_BACKGROUND_UPLOAD_IMAGE: "virtualBackgroundUploadImage",
    SELECTED_VIRTUAL_BACKGROUND_IMAGE_ID: "selectedVirtualBackgroundImageId",
};

export const PORTAL_NAME_CHANGE_FROM = {
    ISCOMPANY_AVAILABLE: "ISCOMPANY_AVAILABLE",
    PRIVACY_POLICY: "PRIVACY_POLICY",
};

export const PARAMS = {
    MICROPHONE: "m",
    OBSERVER: "o",
    AGENT: "id",
    CAMERA: "c",
    SUPPORT_OPTION: "s",
    DOMAIN_ID: "d",
    HOME_SCREEN_BUTTON: "z",
    PID: "pid", // privacy policy ID
    GUEST_NAME: "n",
    CLOSE_TAB: "closetab",
    PLATFORM: "platform",
    REDIRECT_URL: "redirect_url",
    LOG: "log",
};

export const PLATFORM = {
    ZENDESK: "Zendesk",
    SALESFORCE: "Salesforce",
    SERVICENOW: "ServiceNow",
    HUBSPOT: "HubSpot",
};

export const USER_TYPES = {
    AGENT: "AGENT",
    GUEST: "GUEST",
    SILENT_OBSERVER: "SILENT_OBSERVER",
};

export const AGENT_PRE_CALL_NETWORK_TEST_LINK = "/networktest/";

export const SHOWME_BACKGROUND_COLOR = "#2e3d56";

export const SUPPORT_OPTION = {
    BROWSER_FIRST: 1,
    APP_ONLY: 2,
    BROWSER_ONLY: 3,
    ASK_USER: 4,
};

export const EDITION = {
    INSPECT_PROFESSIONAL: "Inspect Professional",
    CONCIERGE_PROFESSIONAL: "Concierge Professional",
    INSPECT_ENTERPRISE: "Inspect Enterprise",
    CONCIERGE_ENTERPRISE: "Concierge Enterprise",
};

export const ENTER_GUEST_NAME_MAX_LENGTH = 50;

export const CONNECTING_SCREEN = {
    ENTER_SESSIONID_SCREEN: "ENTER_SESSIONID_SCREEN",
    ENTER_GUESTNAME_SCREEN: "ENTER_GUESTNAME_SCREEN",
    VIDEO_SCREEN: "VIDEO_SCREEN",
    UPLOAD_FILES_SCREEN: "UPLOAD_FILES_SCREEN",
};

export const DEVICE_TYPES = {
    ANDROID_BROWSER: "1",
    IOS_BROWSER: "2",
    DESKTOP: "3",
    ANDROID_APP: "4",
    IOS_APP: "5",
    SMART_GLASS: "6",
};

export const DEVICE_ORIENTATION_TYPES = {
    ZERO_UNKNOWN: "0",
    ONE_PORTRAIT: "1",
    THREE_LANDSCAPE: "3",
    FOUR_LANDSCAPE_REVERSED: "4",
    TWO_UPSIDE_DOWN: "2",
};

export const FULL_DATE_FORMAT = "DD-MM-YYYY hh:mm:ss A";
export const JOIN_MEETING_START_TIME_FORMATE = "YYYY-MM-DD HH:mm:ss";

export const ZOOM_LEVEL_LIST = {
    ONE: "1",
    TWO: "2",
    THREE: "3",
};

export const ZOOM_LEVEL_VALUE = { 1: 0, 2: 8, 3: 15 };
export const MARKUP_LIVESTREAM_MIN_VERSION = 3.2;
export const GOOGLE_MAP_LINK = "https://maps.google.com?q=";

export const ROOM_TYPE = { P2P: "P2P", SMALL: "SMALLGROUP", GO: "GO", GROUP: "GROUP" };
export const DEFAULT_RESOLUTION = "SD";
export const SCHEDULE_SESSION_ERROR_CODE = 1063;
export const EXTRACT_TEXT_VIEW = {
    PREPARE_VIEW: 1,
    OCR_VIEW: 2,
    OFF_VIEW: 0,
};

export const MARKUP_VIEW = {
    OFF_VIEW: 0,
    PREPARE_VIEW: 1,
    START_MARKUP_VIEW: 2,
};

export const AR_MARKUP_VIEW = {
    OFF_VIEW: 0,
    PREPARE_VIEW: 1,
    START_MARKUP_VIEW: 2,
};

export const MEASUREMENT_VIEW = {
    OFF_VIEW: 0,
    PREPARE_VIEW: 1,
    START_MEASUREMENT_VIEW: 2,
};

export const SHAPE_TYPE = {
    FREEDRAW: "1",
    RECT: "2",
    TEXT: "3",
    CIRCLE: "4",
    BLUR: "5",
    ARROW: "6",
};

export const NAMED_SHAPE_TYPE = {
    FREEDRAW: "path",
    RECT: "rect",
    TEXT: "i-text",
    ARROW: "polygon",
};

export const shapeStatus = {
    DRAW: "1",
    MOVE: "2",
    UNDO: "3",
    REDO: "4",
};

export const SHAPE_THICKNESS = [1, 2, 3, 4, 5, 10, 12, 15, 18, 20];
export const FONT_SIZE = [10, 12, 14, 16, 18, 22, 26, 30, 34, 38];
export const AGENT_DEFAULT_COLOR = "#53e504";
export const COLOR_TO_ANNOT = [
    AGENT_DEFAULT_COLOR,
    "#FF0000",
    "#01DCDC",
    "#5745C3",
    "#C8DC45",
    "#BA8CF3",
    "#4BC1B3",
    "#B57777",
    "#8D99A7",
    "#EE834C",
    "#FFFFFF",
    "#000000",
    "#FB62AE",
    "#AD2EDA",
];

export const KEYBOARD_KEYS = {
    NUMBER_MIN: 48,
    NUMBER_MAX: 57,
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    DELETE: 46,
    CTRLZ: 90,
    CTRLY: 89,
};

export const RECORDING = {
    OFF: "0",
    ON: "1",
    INITON: "2",
    INITOFF: "3",
};

export const CALL_BODY_SCREEN = {
    CONNECTING_SCREEN: "CONNECTING_SCREEN",
    WAITING_SCREEN: "WAITING_SCREEN",
    VIDEO_SCREEN: "VIDEO_SCREEN",
    UPLOAD_FILE_SCREEN: "UPLOAD_FILE_SCREEN",
    NOTIFY_SCREEN: "NOTIFY_SCREEN",
    GALLERY_VIEW: "GALLERY_VIEW",
};

export const AUDIO_STATUS = {
    ENABLED_FOR_THE_AGENT_AND_GUEST_BOTH: 0,
    DISABLE_FOR_AGENT_ONLY: 1,
    DISABLE_FOR_GUEST_ONLY: 2,
    DISABLE_FOR_AGENT_AND_GUEST_BOTH: 3,
};
export const MAX_CHUNK_SIZE = 3400; // Data should be less than the 4KB limit to send data tracks
export const ENGLISH_LANGUAGE_CODES = ["en_AU", "en_CA", "en_GB", "en_US"];

export const TRACK_SUBSCRIBE_FOR = {
    LOCAL: "local",
    REMOTE: "remote",
};

export const BLITZZ_HELP_EMAIL = "support@blitzz.co";

export const SUPPORT_BROWSER_LINKS = {
    SAFARI: "https://support.apple.com/downloads/safari",
    CHROME: "https://www.google.com/chrome/?brand=CHBD&amp;gclid=Cj0KCQiA2vjuBRCqARIsAJL5a-LdXchgOAJa90QQRaIiRj5x_EA79eUb9Eb9zj-FAQ6uoZhKX2tjX-8aApPPEALw_wcB&amp;gclsrc=aw.ds",
    FIREFOX: "https://www.mozilla.org/en-US/firefox/new",
};

export const NETWORK_QUALITY_LEVEL = {
    VERY_BAD_VALUE: 1,
    BAD_VALUE: 2,
    POOR_VALUE: 3,
    GOOD_VALUE: 4,
    EXCELLENT_VALUE: 5,
};

export const NQ_UNSTABLE_PARAM = 2;

export const WHATSAPP_INVITATION_PREVIEW_TEXT = "<company_name>: Click this link to join your remote session:";

export const TWILLIO_URL_ENDPOINT = "/j/";
export const TWILLIO_URL_ENDPOINT_FOR_XIAOMI = "/j";

export const WAITING_CLOCK_ICON = <span className='icon-waiting-clock for-icon'></span>;
